document.querySelectorAll("global-navigation").forEach(element =>{
	const dialog = element.querySelector("#contactDialog");
	const showButton = element.querySelector("#contactLink");
	const closeButton = element.querySelector("#closeDialog");

	// Prevent default action for the anchor tag and show dialog
	if(showButton) {
		showButton.addEventListener("click", (event) => {
			event.preventDefault(); // Prevent link from navigating away
			dialog.showModal(); // Show the dialog
		});
	}

	// Close dialog when "Close" button is clicked
	if(closeButton) {
		closeButton.addEventListener("click", () => {
			dialog.close();
		});
	}

})


